'use client'
export function ExitSessionIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="#A9AFB8"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83333 4.16667C4.91286 4.16667 4.16667 4.91286 4.16667 5.83333L4.16667 14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H9.375C9.83524 15.8333 10.2083 16.2064 10.2083 16.6667C10.2083 17.1269 9.83524 17.5 9.375 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667L2.5 5.83333C2.5 3.99238 3.99238 2.5 5.83333 2.5L9.375 2.5C9.83524 2.5 10.2083 2.8731 10.2083 3.33333C10.2083 3.79357 9.83524 4.16667 9.375 4.16667L5.83333 4.16667ZM12.3274 5.66075C12.6528 5.33531 13.1805 5.33531 13.5059 5.66074L17.2559 9.41073C17.5814 9.73617 17.5814 10.2638 17.2559 10.5892L13.5059 14.3393C13.1805 14.6647 12.6528 14.6647 12.3274 14.3393C12.002 14.0138 12.002 13.4862 12.3274 13.1607L14.6548 10.8333H7.29167C6.83143 10.8333 6.45833 10.4602 6.45833 9.99999C6.45833 9.53975 6.83143 9.16666 7.29167 9.16666L14.6548 9.16666L12.3274 6.83926C12.002 6.51382 12.002 5.98618 12.3274 5.66075Z"
        fill="parent"
      />
    </svg>
  )
}
